import { createFileRoute } from "@tanstack/react-router";
import { loginHead, validateLoginSearch } from "~/lib/login-search.ts";
import { ClawInstallLogin } from "./index.tsx";

/**
 * Catch-all beneath the clawinstall customer login door. Clerk's `<SignIn
 * routing="path" path="/login">` drives its own steps at sub-paths of the
 * door — `/login/factor-one` (email code / password), `/login/factor-two`,
 * `/login/verify`, … — and TanStack needs a route there or the step renders
 * the site 404 (confirmed on clawinstall.ai, 2026-09-06). This is the
 * "TanStack Router catch-all route" Clerk's TanStack Start guide requires for
 * the sign-in page. It ranks below the exact `index.tsx` and the static
 * `sso-callback.tsx`, so it only catches Clerk's own steps.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/login/$")({
  validateSearch: validateLoginSearch,
  head: ({ match }) => loginHead(match.context.identity?.displayName ?? "ClawInstall"),
  component: ClawInstallLogin,
});
